import React from 'react';

import Tabs from '@components/Tabs';
import { SearchScope } from '@hooks/useSearchResults';
import { search_page_path } from '@routes';
import { capitalize } from '@utils/formatting';

const TAB_NAMES: SearchScope[] = [SearchScope.Articles, SearchScope.Forum, SearchScope.Directory];

interface SearchTabsProps {
  query: string;
  scope: SearchScope;
}

const SearchTabs = ({ query, scope }: SearchTabsProps) => {
  const TAB_OPTIONS = TAB_NAMES.map((tab) => ({
    text: capitalize(tab),
    to: tab,
  }));

  return (
    <Tabs
      customPath={({ view }) => search_page_path({ query, scope: view })}
      tabs={TAB_OPTIONS}
      view={scope}
      styles="max-w-[390px] !mx-0 mt-40 sm:mt-72"
    />
  );
};

export default SearchTabs;
